'use strict';

module.exports = {
  // Auth config can either be set with env variables or in e.g. staging.js in the same object format as below
  auth: {
    AUTH0_DOMAIN: 'escio.eu.auth0.com',
    AUTH0_CLIENT_ID: 'x4yyKgaal3sT9Hn85yNG6ik5Rbyy9XfM',
    AUTH0_REDIRECT_URL: 'https://admin.staging.motorgruppen.no'
  },
  contentful: {
    // AccessToken are fetched through auth0 login
    // accessToken: '',
    spaceId: 'mt8w0y3iajsh',
        environment: 'master'
      },
  filestack: {
    apiKey: 'A10yUWQoQCqdgb5qLJVD2z'
  },
  services: {
    MG_PROTOCOL: 'https',
    MG_DOMAIN: 'api.staging.motorgruppen.no',
    MG_PORT: 443,
    MG_SERVICES_BASE: '/services/'
  },
  taskQueue: {
    protocol: 'https',
    hostname: 'api.staging.motorgruppen.no',
    port: 443,
    pathname: '/task-queue/'
  }
};
